/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiBarberShiftId200, GetApiBarberShiftId400, GetApiBarberShiftId401, GetApiBarberShiftId403, GetApiBarberShiftId404, GetApiBarberShiftId500, GetApiBarberShiftIdPathParams, GetApiBarberShiftIdQueryResponse } from "../entities/GetApiBarberShiftId";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsShiftDetailsOutputSchema } from "./models/shiftDetailsOutputSchema";
import { z } from "zod/v4";

export const getApiBarberShiftIdPathParamsSchema = z.object({
    "id": z.coerce.number().int().describe("ID смены")
    }) as unknown as z.ZodType<GetApiBarberShiftIdPathParams>

/**
 * @description OK
 */
export const getApiBarberShiftId200Schema = z.lazy(() => modelsShiftDetailsOutputSchema) as unknown as z.ZodType<GetApiBarberShiftId200>

/**
 * @description Bad Request
 */
export const getApiBarberShiftId400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftId400>

/**
 * @description Unauthorized
 */
export const getApiBarberShiftId401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftId401>

/**
 * @description Forbidden
 */
export const getApiBarberShiftId403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftId403>

/**
 * @description Not Found
 */
export const getApiBarberShiftId404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftId404>

/**
 * @description Internal Server Error
 */
export const getApiBarberShiftId500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftId500>

export const getApiBarberShiftIdQueryResponseSchema = z.lazy(() => getApiBarberShiftId200Schema) as unknown as z.ZodType<GetApiBarberShiftIdQueryResponse>